// PasswordResetModal.js - VERSION ACTUALIZADA PARA WHATSAPP
import React, { useState } from 'react';
import { X, ArrowRight, AlertTriangle, CheckCircle2, MessageCircle, Check } from 'lucide-react';
import logo from '../imgs/Logo_Fcn.png';

// Mismo sistema de campos y botones que CredentialRequestModal.js y Login.js
const LABEL_CLASS = 'block text-center text-xs font-medium uppercase tracking-wide text-neutral-300 mb-2.5';
const INPUT_CLASS =
  'w-full px-0 py-2.5 bg-transparent border-0 border-b border-neutral-100 text-[15px] text-cafe-800 placeholder:text-neutral-200 focus:outline-none focus:border-b-2 focus:border-cafe-700 transition-all duration-200';
const PRIMARY_BUTTON_CLASS =
  'group flex items-center justify-center px-7 py-3 bg-cafe-700 rounded-xl text-white text-sm font-semibold tracking-wide shadow-[0_1px_2px_rgba(0,0,0,0.15),0_10px_24px_-10px_rgba(62,39,35,0.6)] hover:bg-cafe-800 hover:-translate-y-px hover:shadow-[0_1px_2px_rgba(0,0,0,0.15),0_14px_28px_-10px_rgba(62,39,35,0.7)] active:translate-y-0 active:scale-[0.99] transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:active:scale-100';
const GHOST_BUTTON_CLASS =
  'px-5 py-2.5 text-sm font-medium text-neutral-300 rounded-xl hover:text-cafe-700 hover:bg-cafe-100/50 transition-colors duration-200 disabled:opacity-50';

const PasswordResetModal = ({ show, onClose }) => {
  const [emailOUsuario, setEmailOUsuario] = useState(''); // Cambiado para aceptar ambos
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [verificationToken, setVerificationToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState('request'); // 'request' | 'token' | 'success' | 'error'
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [userPhone, setUserPhone] = useState(''); // Para mostrar el teléfono
  const [tokenKey, setTokenKey] = useState('');
  const [debugToken, setDebugToken] = useState(''); // Para mostrar el token en pruebas

  const API_BASE_URL = process.env.REACT_APP_API_URL;

  // Paso 1: Enviar token por WhatsA
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');


    // Validaciones básicas
    if (!emailOUsuario.trim()) {
      setError('Por favor ingrese su correo electrónico o nombre de usuario');
      setIsLoading(false);
      return;
    }

    if (!newPassword.trim()) {
      setError('Por favor ingrese la nueva contraseña');
      setIsLoading(false);
      return;
    }

    if (!confirmPassword.trim()) {
      setError('Por favor confirme la nueva contraseña');
      setIsLoading(false);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      setIsLoading(false);
      return;
    }

    if (newPassword.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      setIsLoading(false);
      return;
    }

    // Validar que contenga al menos una mayúscula
    if (!/[A-Z]/.test(newPassword)) {
      setError('La contraseña debe contener al menos una letra mayúscula');
      setIsLoading(false);
      return;
    }

    // Validar que contenga al menos una minúscula
    if (!/[a-z]/.test(newPassword)) {
      setError('La contraseña debe contener al menos una letra minúscula');
      setIsLoading(false);
      return;
    }

    // Validar que contenga al menos un número
    if (!/[0-9]/.test(newPassword)) {
      setError('La contraseña debe contener al menos un número');
      setIsLoading(false);
      return;
    }

    // Validar que contenga al menos un caracter especial
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)) {
      setError('La contraseña debe contener al menos un carácter especial (!@#$%^&*(),.?":{}|<>)');
      setIsLoading(false);
      return;
    }

    try {
      // Enviar solicitud para generar y enviar token
      const response = await fetch(`${API_BASE_URL}/auth/send-reset-token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Usuario: emailOUsuario.trim(), // Enviar email o usuario
          NuevaContrasenia: newPassword
        }),
      });

      // Verificar si la respuesta es JSON válido
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new Error('El servidor no devolvió una respuesta JSON válida');
      }

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.error || 'Error al procesar la solicitud');
      }

      // Guardar datos para el siguiente paso - ACTUALIZADO PARA WHATSAPP
      setTokenKey(responseData.tokenKey);
      setUserPhone(responseData.phone || ''); // Usar phone en lugar de email
      setDebugToken(responseData.debug_token || ''); // Para mostrar en pruebas
      
      // Mensaje actualizado para WhatsApp
      const phoneDisplay = responseData.phone ? 
        `al WhatsApp ${responseData.phone}` : 
        'a su WhatsApp registrado';
      
      setMessage(`Se ha enviado un código de verificación ${phoneDisplay}`);
      setStep('token');
      
    } catch (err) {
      console.error('Error al enviar token:', err);
      if (err.message.includes('JSON')) {
        setError('Error de comunicación con el servidor. Verifica la configuración.');
        setStep('error');
      } else if (err.message.includes('nueva contraseña no puede ser igual')) {
        setError(err.message);
        // Mantenerse en el step 'request' para que el usuario cambie la contraseña
      } else if (err.message.includes('Error enviando mensaje por WhatsApp')) {
        setError('Error al enviar el mensaje por WhatsApp. Verifica que tu número esté registrado correctamente.');
        setStep('error');
      } else if (err.message.includes('Error de autorización con GreenAPI')) {
        setError('Error de configuración del servicio de WhatsApp. Contacta al administrador del sistema.');
        setStep('error');
      } else if (err.message.includes('no tiene teléfono asignado')) {
        setError('Tu cuenta no tiene un número de WhatsApp asignado. Contacta al administrador del sistema.');
        setStep('error');
      } else {
        setError(err.message || 'Error al procesar la solicitud. Verifique el correo electrónico o nombre de usuario.');
        setStep('error');
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Paso 2: Verificar token y cambiar contraseña
  const handleVerifyToken = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');

    // Validación del token
    if (!verificationToken.trim()) {
      setError('Por favor ingrese el código de verificación');
      setIsLoading(false);
      return;
    }

    // Validar que el token tenga 6 dígitos
    if (!/^\d{6}$/.test(verificationToken.trim())) {
      setError('El código debe tener exactamente 6 dígitos');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/auth/verify-and-reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tokenKey: tokenKey,
          verificationToken: verificationToken.trim()
        }),
      });

      // Verificar si la respuesta es JSON válido
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new Error('El servidor no devolvió una respuesta JSON válida');
      }

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.error || 'Error al procesar la solicitud');
      }

      setStep('success');
      setMessage('Contraseña restablecida exitosamente. Ya puedes iniciar sesión con tu nueva contraseña.');
      
      // Limpiar el formulario
      setEmailOUsuario(''); // Cambiado
      setNewPassword('');
      setConfirmPassword('');
      setVerificationToken('');
      setDebugToken('');
      
    } catch (err) {
      console.error('Error al verificar token:', err);
      if (err.message.includes('JSON')) {
        setError('Error de comunicación con el servidor. Verifica la configuración.');
      } else if (err.message.includes('expirado')) {
        setError('El código de verificación ha expirado. Solicita un nuevo código.');
      } else if (err.message.includes('incorrecto')) {
        setError('Código de verificación incorrecto. Verifica el código enviado a tu WhatsApp.');
      } else {
        setError(err.message || 'Código de verificación incorrecto o expirado.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    // Resetear el estado del modal
    setEmailOUsuario(''); // Cambiado
    setNewPassword('');
    setConfirmPassword('');
    setVerificationToken('');
    setTokenKey('');
    setUserPhone('');
    setDebugToken('');
    setError('');
    setMessage('');
    setStep('request');
    setIsLoading(false);
    onClose();
  };

  const handleTryAgain = () => {
    setStep('request');
    setError('');
    setMessage('');
    setVerificationToken('');
    setNewPassword('');
    setConfirmPassword('');
    setDebugToken('');
  };

  const handleBackToToken = () => {
    setStep('token');
    setError('');
    setMessage('');
  };

  const handleBackToStart = () => {
    setStep('request');
    setError('');
    setMessage('');
    setVerificationToken('');
    setNewPassword('');
    setConfirmPassword('');
    setDebugToken('');
  };

  if (!show) return null;

  const requirements = [
    { label: 'Mínimo 8 caracteres', ok: newPassword.length >= 8 },
    { label: 'Una letra mayúscula', ok: /[A-Z]/.test(newPassword) },
    { label: 'Una letra minúscula', ok: /[a-z]/.test(newPassword) },
    { label: 'Un número', ok: /[0-9]/.test(newPassword) },
    { label: 'Un carácter especial', ok: /[!@#$%^&*(),.?":{}|<>]/.test(newPassword) },
  ];

  const renderRequirement = (ok, label) => (
    <li
      key={label}
      className={`flex items-center text-xs transition-colors duration-200 ${ok ? 'text-cafe-700 font-medium' : 'text-neutral-300'}`}
    >
      {ok ? (
        <Check className="h-3.5 w-3.5 mr-1.5 flex-shrink-0" />
      ) : (
        <span className="h-1 w-1 rounded-full bg-current ml-[5px] mr-[11px] flex-shrink-0" />
      )}
      {label}
    </li>
  );

  const errorBox = error && (
    <div key={error} className="bg-red-50 rounded-md px-4 py-3 flex items-start animate-shake">
      <AlertTriangle className="h-4 w-4 text-red-600 mt-0.5 flex-shrink-0" />
      <p className="text-red-700 text-sm ml-2.5 text-left">{error}</p>
    </div>
  );

  const heading = (title, subtitle) => (
    <div className="mb-9 text-center">
      <h2 className="text-2xl font-bold text-cafe-800 mb-2 tracking-tight">{title}</h2>
      {subtitle && <p className="text-sm text-neutral-300 leading-relaxed">{subtitle}</p>}
    </div>
  );

  const statusIcon = (Icon, tone = 'text-cafe-700', bg = 'bg-neutral-50/50') => (
    <div className={`w-14 h-14 rounded-full ${bg} flex items-center justify-center mx-auto mb-5`}>
      <Icon className={`h-7 w-7 ${tone}`} />
    </div>
  );

  return (
    <div className="fixed inset-0 bg-cafe-800 bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className="bg-white text-left rounded-xl shadow-[0_40px_90px_-25px_rgba(59,39,25,0.4)] w-full max-w-md max-h-[92vh] overflow-y-auto animate-card-in">
        <div className="relative p-6 sm:p-10">
          <button
            onClick={handleClose}
            aria-label="Cerrar"
            className="absolute top-5 right-5 text-neutral-200 hover:text-neutral-400 transition-colors duration-200 disabled:opacity-40"
            disabled={isLoading}
          >
            <X className="h-5 w-5" />
          </button>

          <div className="flex justify-center mb-8">
            <img src={logo} alt="Logo Fondo Cafetero" className="h-16" />
          </div>

          {step === 'request' && (
            <>
              {heading('Restablecer contraseña', 'Ingrese su usuario y elija una nueva contraseña.')}

              <form onSubmit={handleSubmit} className="space-y-7">
                {errorBox}

                <div className="group">
                  <label htmlFor="reset-email-usuario" className={LABEL_CLASS}>
                    Correo electrónico o usuario
                  </label>
                  <input
                    id="reset-email-usuario"
                    type="text"
                    value={emailOUsuario}
                    onChange={(e) => setEmailOUsuario(e.target.value)}
                    className={INPUT_CLASS}
                    maxLength="100"
                    autoComplete="username"
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="group">
                  <label htmlFor="new-password" className={LABEL_CLASS}>
                    Nueva contraseña
                  </label>
                  <input
                    id="new-password"
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className={INPUT_CLASS}
                    maxLength="100"
                    autoComplete="new-password"
                    required
                    disabled={isLoading}
                  />
                  {newPassword && (
                    <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-1.5">
                      {requirements.map((r) => renderRequirement(r.ok, r.label))}
                    </ul>
                  )}
                </div>

                <div className="group">
                  <label htmlFor="confirm-password" className={LABEL_CLASS}>
                    Confirmar nueva contraseña
                  </label>
                  <input
                    id="confirm-password"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className={INPUT_CLASS}
                    maxLength="100"
                    autoComplete="new-password"
                    required
                    disabled={isLoading}
                  />
                  {confirmPassword && (
                    <ul className="mt-4">
                      {renderRequirement(newPassword === confirmPassword, 'Las contraseñas coinciden')}
                    </ul>
                  )}
                </div>

                <div className="flex justify-center pt-3">
                  <button type="submit" disabled={isLoading} className={PRIMARY_BUTTON_CLASS}>
                    {isLoading ? (
                      <>
                        <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2.5"></span>
                        Enviando código...
                      </>
                    ) : (
                      <>
                        Enviar código por WhatsApp
                        <ArrowRight className="h-4 w-4 ml-2 transition-transform duration-200 group-hover:translate-x-1" />
                      </>
                    )}
                  </button>
                </div>
              </form>
            </>
          )}

          {step === 'token' && (
            <>
              {statusIcon(MessageCircle)}
              {heading('Verificar código', message)}

              <form onSubmit={handleVerifyToken} className="space-y-7">
                {userPhone && (
                  <p className="text-center text-xs text-neutral-300 -mt-4">{userPhone}</p>
                )}

                {/* DEBUG: Mostrar el token para pruebas */}
                {debugToken && (
                  <div className="bg-yellow-50 rounded-md px-4 py-3 flex items-start">
                    <AlertTriangle className="h-4 w-4 text-yellow-600 mt-0.5 flex-shrink-0" />
                    <p className="text-yellow-700 text-sm ml-2.5 text-left">
                      <strong>DEBUG (solo pruebas):</strong> código <span className="font-mono text-base">{debugToken}</span>
                    </p>
                  </div>
                )}

                {errorBox}

                <div className="group">
                  <label htmlFor="verification-token" className={LABEL_CLASS}>
                    Código de verificación
                  </label>
                  <input
                    id="verification-token"
                    type="text"
                    inputMode="numeric"
                    value={verificationToken}
                    onChange={(e) => {
                      // Solo permitir números y máximo 6 caracteres
                      const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                      setVerificationToken(value);
                    }}
                    className="w-full px-0 py-2.5 bg-transparent border-0 border-b border-neutral-100 text-center text-2xl font-mono tracking-[0.5em] text-cafe-800 placeholder:text-neutral-100 focus:outline-none focus:border-b-2 focus:border-cafe-700 transition-all duration-200"
                    placeholder="000000"
                    maxLength="6"
                    autoComplete="one-time-code"
                    required
                    disabled={isLoading}
                  />
                  <p className="mt-3 text-xs text-neutral-300 text-center">
                    Ingrese los 6 dígitos enviados a su WhatsApp. El código expira en 15 minutos.
                  </p>
                </div>

                <div className="flex flex-col items-center gap-2 pt-3">
                  <button
                    type="submit"
                    disabled={isLoading || verificationToken.length !== 6}
                    className={PRIMARY_BUTTON_CLASS}
                  >
                    {isLoading ? (
                      <>
                        <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2.5"></span>
                        Verificando...
                      </>
                    ) : (
                      <>
                        Cambiar contraseña
                        <ArrowRight className="h-4 w-4 ml-2 transition-transform duration-200 group-hover:translate-x-1" />
                      </>
                    )}
                  </button>
                  <button
                    type="button"
                    onClick={handleTryAgain}
                    disabled={isLoading}
                    className={GHOST_BUTTON_CLASS}
                  >
                    Volver
                  </button>
                </div>
              </form>
            </>
          )}

          {step === 'success' && (
            <div className="text-center animate-card-in">
              {statusIcon(CheckCircle2)}
              {heading('Contraseña actualizada', message)}
              <div className="flex justify-center">
                <button onClick={handleClose} className={PRIMARY_BUTTON_CLASS}>
                  Cerrar
                </button>
              </div>
            </div>
          )}

          {step === 'error' && (
            <div className="text-center animate-card-in">
              {statusIcon(AlertTriangle, 'text-red-600', 'bg-red-50')}
              {heading('No se pudo completar', error)}
              <div className="flex flex-col items-center gap-2">
                <button onClick={handleBackToStart} className={PRIMARY_BUTTON_CLASS}>
                  Intentar nuevamente
                </button>
                <button onClick={handleClose} className={GHOST_BUTTON_CLASS}>
                  Cerrar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PasswordResetModal;
